import { ClassLeaderboard } from "services/classLeaderboardsService/types";

import actionTypes from "../action-types";

export function receiveClassLeaderboard(leaderboard: ClassLeaderboard) {
  return {
    type: actionTypes.RECEIVE_LEADERBOARD,
    payload: leaderboard
  };
}
